import { WeightMeasurementUnits } from './measurementUnits.constants';

export const periodOptions = [
  { label: 'Hour', value: 'HOUR' },
  { label: 'Day Part', value: 'DAY_PART' },
  { label: 'Days', value: 'DAY' },
  { label: 'Week', value: 'WEEK' },
  { label: 'Month', value: 'MONTH' },
];

export const potatoStationOptions = [
  { label: 'Primary potato station', value: '1' },
  { label: 'Secondary potato station', value: '2' },
];

export const weightMeasurementUnits = {
  [WeightMeasurementUnits.Kilograms]: 'KG',
  [WeightMeasurementUnits.Pounds]: 'LB',
};

export const friedExportOptions = [
  'CONTAINERS_REGISTERED_PRODUCTION',
  'CONTAINERS_REGISTERED_SCHEDULED',
  'CONTAINERS_RECOMMENDED_PRODUCTION',
  'CONTAINERS_RECOMMENDED_SCHEDULED',
  'COOKED_PRODUCTION',
  'COOKED_SCHEDULED_PRODUCTION',
  'WASTE',
  'RECOMMENDED_PRODUCTION',
  'RECOMMENDED_SCHEDULED_PRODUCTION',
  'PACKAGES',
  'PRS',
  'INBOUND_CONVEYOR',
  'OUTBOUND_CONVEYOR',
  'STOCK_OUT',
  'TASK_DELAY',
  'FRYER_CYCLES',
  'FRYER_AVAILABILITY',
  'HOLD_TIMES_BEFORE_ADJUSTMENT',
  'HOLD_TIMES_AFTER_ADJUSTMENT',
  'HOLD_TIMES_DETAILS_BEFORE_ADJUSTMENT',
  'HOLD_TIMES_DETAILS_AFTER_ADJUSTMENT',
  'TOTAL_HOLD_TIME_REPORT',
  'TIME_IN_CHUTES_ONLY_HOLD_TIME_REPORT',
];

export const grilledExportOptions = [
  'RECOMMENDED',
  'TRAYS_REGISTERED',
  'TRAYS_RECOMMENDED',
  'PRS',
  'FRYER_CYCLES',
  'FRYER_AVAILABILITY',
];

export const exportOptionsMap = {
  FRIED: friedExportOptions,
  GRILLED: grilledExportOptions,
};

export const exportOptionsKeyMap = {
  FRIED: 'friedExportOptions',
  GRILLED: 'grilledExportOptions',
};

export const DashboardSections = {
  Summary: { id: 'summary', title: 'Summary' },
  ConveyorFlow: { id: 'conveyorFlow', title: 'Conveyor Flow' },
  Trends: { id: 'trends', title: 'Trends' },
  Total: { id: 'total', title: 'Total' },
  PerformanceTriangle: { id: 'performanceTriangle', title: 'Performance Triangle' },
  PerformanceRatios: { id: 'performanceRatios', title: 'Performance Ratios' },
  Cooked: { id: 'cooked', title: 'Cooked' },
  Waste: { id: 'waste', title: 'Waste' },
  Recommended: { id: 'recommended', title: 'Recommended' },
  Containers: { id: 'containers', title: 'Containers' },
  Trays: { id: 'trays', title: 'Trays' },
  Conveyors: { id: 'conveyors', title: 'Conveyors' },
  Prs: { id: 'prs', title: 'Pan Return Station (PRS)' },
  Mtrs: { id: 'mtrs', title: 'Merco Tray Return Station (MTRS)' },
  StockOut: { id: 'stockOut', title: 'Material Stock Outs' },
  BreadingTaskDelay: { id: 'breadingTaskDelay', title: 'Breading Task Delay' },
  Fryers: { id: 'fryers', title: 'Fryers' },
  Grills: { id: 'grills', title: 'Grills' },
  HoldTimes: { id: 'holdTimes', title: 'Hold Times' },
  Packages: { id: 'packages', title: 'Packages' },
};

export const DashboardSectionLayouts = {
  summary: [
    DashboardSections.Total.id,
    DashboardSections.PerformanceTriangle.id,
    DashboardSections.PerformanceRatios.id,
    DashboardSections.Cooked.id,
    DashboardSections.Recommended.id,
    DashboardSections.Waste.id,
    DashboardSections.Containers.id,
    DashboardSections.Packages.id,
    DashboardSections.Conveyors.id,
    DashboardSections.Prs.id,
    DashboardSections.Mtrs.id,
    DashboardSections.StockOut.id,
    DashboardSections.BreadingTaskDelay.id,
    DashboardSections.Fryers.id,
    DashboardSections.Grills.id,
    DashboardSections.HoldTimes.id,
  ],
  charts: [
    DashboardSections.Summary.id,
    DashboardSections.ConveyorFlow.id,
    DashboardSections.Trends.id,
    DashboardSections.Total.id,
    DashboardSections.PerformanceRatios.id,
    DashboardSections.Cooked.id,
    DashboardSections.Waste.id,
    DashboardSections.Recommended.id,
    DashboardSections.Containers.id,
    DashboardSections.Conveyors.id,
    DashboardSections.Prs.id,
    DashboardSections.Mtrs.id,
    DashboardSections.StockOut.id,
    DashboardSections.BreadingTaskDelay.id,
    DashboardSections.Fryers.id,
    DashboardSections.Grills.id,
    DashboardSections.HoldTimes.id,
  ],
};
